export function moonArt(m){
  const [lite,base,dark]=m.hue, g="mg-"+m.id;
  return `<svg viewBox="0 0 64 64" aria-label="${m.k} moon">
    <defs>
      <radialGradient id="${g}" cx="35%" cy="30%" r="78%">
        <stop offset="0%" stop-color="${lite}"/><stop offset="52%" stop-color="${base}"/><stop offset="100%" stop-color="${dark}"/>
      </radialGradient>
      <radialGradient id="${g}h" cx="50%" cy="50%" r="50%">
        <stop offset="45%" stop-color="${base}" stop-opacity=".5"/><stop offset="100%" stop-color="${base}" stop-opacity="0"/>
      </radialGradient>
      <clipPath id="${g}c"><circle cx="32" cy="30" r="22"/></clipPath>
    </defs>
    <circle cx="32" cy="30" r="30" fill="url(#${g}h)">
      <animate attributeName="opacity" values="1;.55;1" dur="2.6s" repeatCount="indefinite"/>
    </circle>
    <circle cx="32" cy="30" r="22" fill="url(#${g})"/>
    <g clip-path="url(#${g}c)">
      <circle cx="24" cy="24" r="4.2" fill="${dark}" opacity=".4"/>
      <circle cx="38" cy="20" r="2.6" fill="${dark}" opacity=".35"/>
      <circle cx="30" cy="37" r="5.2" fill="${dark}" opacity=".38"/>
      <circle cx="41" cy="37" r="3" fill="${dark}" opacity=".33"/>
      <circle cx="21" cy="34" r="2.1" fill="${dark}" opacity=".3"/>
      <circle cx="36" cy="29" r="1.7" fill="${dark}" opacity=".3"/>
      <ellipse cx="44" cy="40" rx="22" ry="24" fill="${dark}" opacity=".26"/>
    </g>
    <rect x="19" y="51" width="26" height="12" rx="6" fill="rgba(0,0,0,.55)" stroke="${lite}" stroke-width=".8"/>
    <text x="32" y="60" text-anchor="middle" font-family="Nunito,sans-serif" font-size="9" font-weight="900" fill="${lite}">${m.k}</text>
  </svg>`;
}
export function fillerArt(f){
  const spark=(x,y,d)=>`<g fill="#FFFFFF"><path d="M${x} ${y-4} L${x+1.2} ${y-1.2} L${x+4} ${y} L${x+1.2} ${y+1.2} L${x} ${y+4} L${x-1.2} ${y+1.2} L${x-4} ${y} L${x-1.2} ${y-1.2} Z">
    <animate attributeName="opacity" values="0;1;0" dur="${d}s" repeatCount="indefinite"/></path></g>`;
  if(f.id==="bell")return `<svg viewBox="0 0 64 64" aria-label="golden bell">
    <defs><radialGradient id="fg-bell" cx="35%" cy="28%" r="80%">
      <stop offset="0%" stop-color="#FFF0B8"/><stop offset="55%" stop-color="#FFC53D"/><stop offset="100%" stop-color="#8A4A00"/>
    </radialGradient></defs>
    <ellipse cx="32" cy="53" rx="15" ry="3" fill="#000" opacity=".3"/>
    <path d="M32 11 C21 11 19 25 18 35 C17.5 41 14.5 43.5 14.5 46 L49.5 46 C49.5 43.5 46.5 41 46 35 C45 25 43 11 32 11 Z"
      fill="url(#fg-bell)" stroke="#7A4200" stroke-width="2" stroke-linejoin="round"/>
    <circle cx="32" cy="10" r="3.6" fill="#FFC53D" stroke="#7A4200" stroke-width="1.6"/>
    <circle cx="32" cy="50" r="4.2" fill="#7A4200"/>
    <ellipse cx="25.5" cy="24" rx="3.4" ry="8" fill="#FFFFFF" opacity=".5" transform="rotate(-14 25.5 24)"/>
    ${spark(45,17,1.9)}${spark(19,40,2.6)}</svg>`;
  if(f.id==="cherry")return `<svg viewBox="0 0 64 64" aria-label="cherries">
    <defs><radialGradient id="fg-cher" cx="34%" cy="28%" r="80%">
      <stop offset="0%" stop-color="#FF9A8F"/><stop offset="55%" stop-color="#E8250A"/><stop offset="100%" stop-color="#6E0A05"/>
    </radialGradient></defs>
    <path d="M25 35 Q30 16 41 12" fill="none" stroke="#2E7A1D" stroke-width="3.2" stroke-linecap="round"/>
    <path d="M42 37 Q39 20 41 12" fill="none" stroke="#2E7A1D" stroke-width="3.2" stroke-linecap="round"/>
    <path d="M41 12 Q50 8 55 14 Q47 18 41 12 Z" fill="#3DA52E" stroke="#1D6E12" stroke-width="1.4"/>
    <circle cx="24" cy="43" r="9.5" fill="url(#fg-cher)" stroke="#6E0A05" stroke-width="2"/>
    <circle cx="42" cy="45" r="9.5" fill="url(#fg-cher)" stroke="#6E0A05" stroke-width="2"/>
    <circle cx="21" cy="40" r="2.6" fill="#FFFFFF" opacity=".65"/>
    <circle cx="39" cy="42" r="2.6" fill="#FFFFFF" opacity=".65"/>
    ${spark(52,30,2.2)}</svg>`;
  if(f.id==="horseshoe")return `<svg viewBox="0 0 64 64" aria-label="horseshoe">
    <defs><radialGradient id="fg-shoe" cx="35%" cy="28%" r="85%">
      <stop offset="0%" stop-color="#FFF0B8"/><stop offset="55%" stop-color="#FFC53D"/><stop offset="100%" stop-color="#8A4A00"/>
    </radialGradient></defs>
    <path d="M19 13 C9 30 15 47 32 52 C49 47 55 30 45 13 L37 17 C44 30 41 41 32 44 C23 41 20 30 27 17 Z"
      fill="url(#fg-shoe)" stroke="#7A4200" stroke-width="2" stroke-linejoin="round"/>
    <rect x="16.5" y="11" width="12" height="6" rx="2" fill="#FFC53D" stroke="#7A4200" stroke-width="1.5"/>
    <rect x="35.5" y="11" width="12" height="6" rx="2" fill="#FFC53D" stroke="#7A4200" stroke-width="1.5"/>
    <circle cx="20" cy="27" r="1.7" fill="#7A4200"/><circle cx="23" cy="36" r="1.7" fill="#7A4200"/>
    <circle cx="32" cy="47" r="1.7" fill="#7A4200"/><circle cx="41" cy="36" r="1.7" fill="#7A4200"/>
    <circle cx="44" cy="27" r="1.7" fill="#7A4200"/>
    ${spark(32,20,2.0)}</svg>`;
  return `<svg viewBox="0 0 64 64" aria-label="lucky seven">
    <defs><linearGradient id="fg-svn" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="#FF7A5A"/><stop offset="55%" stop-color="#E8250A"/><stop offset="100%" stop-color="#8A0A05"/>
    </linearGradient></defs>
    <!-- The old path ran the top bar from x=13 to x=49 with the diagonal
         hanging off the middle, so the bar read as the crossbar of a T and the
         descender got lost at card size. A 7 hangs its leg off the RIGHT end
         of the bar; the bar is also thinner now so the leg carries the shape. -->
    <path d="M14 12 L50 12 L50 20 L34 52 L20 52 L36 20 L14 20 Z"
      fill="url(#fg-svn)" stroke="#FFE08A" stroke-width="2.6" stroke-linejoin="round"
      transform="rotate(-4 32 32)"/>
    <path d="M18 16 L46 16" stroke="#FFFFFF" stroke-width="2" opacity=".5" stroke-linecap="round" transform="rotate(-4 32 32)"/>
    ${spark(48,40,1.8)}${spark(14,16,2.4)}</svg>`;
}
export function symArt(s){return s.type==="moon"?moonArt(s):fillerArt(s);}
